module.exports = __webpack_public_path__ + "img/granstra_black.307e3f79.svg";